"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var React = _interopRequireWildcard(require("react"));
var _IconContainer = require("./utils/IconContainer");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var LayoutImmersive = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var randomId = Math.random().toString(16).substring(2);
  return /*#__PURE__*/React.createElement(_IconContainer.PureIconContainer, Object.assign({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("svg", {
    width: '1em',
    height: '1em',
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "icon_LayoutImmersive_".concat(randomId, "_a"),
    style: {
      maskType: 'alpha'
    },
    maskUnits: "userSpaceOnUse",
    x: -1,
    y: 2,
    width: 17,
    height: 12
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M.725 2.005a.652.652 0 0 0-.72.75C.203 3.995.536 6.319.536 8s-.333 4.005-.533 5.245a.652.652 0 0 0 .72.75c1.56-.192 4.902-.567 7.272-.567s5.711.374 7.272.567a.652.652 0 0 0 .72-.75c-.2-1.24-.533-3.564-.533-5.245s.333-4.005.533-5.245a.652.652 0 0 0-.72-.75c-1.56.192-4.902.567-7.272.567S2.285 2.197.725 2.005ZM5.997 7.5a1.75 1.75 0 1 0-.001-3.499 1.75 1.75 0 0 0 0 3.499Zm-3.498 3.1c0-1.16 1.399-2.1 3.498-2.1 1.153 0 2.096.284 2.71.732.075.055.144.111.209.17.373.34.58.753.58 1.198a1.4 1.4 0 0 1-1.118 1.372l-.02.003h-.002a1.443 1.443 0 0 1-.26.025H3.898a1.4 1.4 0 0 1-1.4-1.4Zm8.062 0c0-.631-.234-1.19-.602-1.643.154-.013.313-.02.477-.02 1.131 0 2.03.313 2.554.79.326.297.507.658.507 1.048A1.225 1.225 0 0 1 12.272 12h-2.146c.274-.398.435-.88.435-1.4Zm1.407-4.069a1.53 1.53 0 1 1-3.061.001 1.53 1.53 0 0 1 3.061 0Z"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon_LayoutImmersive_".concat(randomId, "_a)")
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h16v16H0z"
  }))));
});
var _default = LayoutImmersive;
exports["default"] = _default;